import i18n from 'utils/i18n'
import {
  filterTypes,
  CHECKBOX_LIST,
  offersFiltersTitle,
  offersFiltersName,
  RRP_INTERVAL,
  retailWinesFiltersKey,
  retaiPriceReportFilterTitle,
} from 'utils/consts'

export const getRetailPriceReportFiltersCollection = () => {
  return [
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineCountryFilter),
      filterName: offersFiltersName.countryFilter,
      apiFilterName: retailWinesFiltersKey.wineCountryFilter,
      showCount: false,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.geoIndicationFilter),
      filterName: offersFiltersName.geoIndicationFilter,
      apiFilterName: retailWinesFiltersKey.geoIndicationFilter,
      showCount: false,
    },

    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineTypeFilter),
      filterName: offersFiltersName.wineTypeFilter,
      apiFilterName: retailWinesFiltersKey.wineTypeFilter,
      showCount: false,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineColourFilter),
      filterName: offersFiltersName.wineColourFilter,
      apiFilterName: retailWinesFiltersKey.wineColourFilter,
      showCount: false,
    },
    {
      type: filterTypes[RRP_INTERVAL],
      title: i18n.t(retaiPriceReportFilterTitle.priceFilter),
      filterName: offersFiltersName.retailPriceFilter,
      apiFilterName: retailWinesFiltersKey.retailPriceFilter,
      showCount: false,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.producerFilter),
      filterName: offersFiltersName.producerFilter,
      apiFilterName: retailWinesFiltersKey.producerFilter,
      showCount: false,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.grapeFilter),
      filterName: offersFiltersName.grapeFilter,
      apiFilterName: retailWinesFiltersKey.grapeFilter,
      showCount: false,
    },
  ]
}
